"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Padding = void 0;
var Padding;
(function (Padding) {
    Padding["None"] = "u-pad-none";
    Padding["Normal"] = "u-pad";
    Padding["Large"] = "u-pad-large";
    Padding["XLarge"] = "u-pad-xl";
    Padding["Small"] = "u-pad-small";
    Padding["Half"] = "u-pad-half";
    Padding["Double"] = "u-pad-double";
    Padding["TopBottom"] = "u-pad-top-bottom";
    Padding["TopBottomLarge"] = "u-pad-top-bottom-large";
    Padding["TopBottomHalf"] = "u-pad-top-bottom-half";
    Padding["TopBottomDouble"] = "u-pad-top-bottom-double";
    Padding["LeftRight"] = "u-pad-left-right";
    Padding["LeftRightLarge"] = "u-pad-left-right-large";
    Padding["LeftRightHalf"] = "u-pad-left-right-half";
    Padding["LeftRightDouble"] = "u-pad-left-right-double";
    Padding["Top"] = "u-pad-top";
    Padding["TopLarge"] = "u-pad-top-large";
    Padding["Bottom"] = "u-pad-bottom";
    Padding["BottomLarge"] = "u-pad-bottom-large";
    Padding["Left"] = "u-pad-left";
    Padding["LeftLarge"] = "u-pad-left-large";
    Padding["Right"] = "u-pad-right";
    Padding["RightLarge"] = "u-pad-right-large";
})(Padding = exports.Padding || (exports.Padding = {}));
//# sourceMappingURL=Padding.js.map